"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareSagas = void 0;
var ShareAction_1 = require("@/pages/common/actions/ShareAction");
var effects_1 = require("redux-saga/effects");
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var getCopyUrl = function (state) { return state.share.url; };
var watchPopupNoScroll = function () {
    var payload, state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(ShareAction_1.default.ON_SET_SHARE_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                state = payload;
                if (!state) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(WindowApi_1.setNoScrollBody, true)];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.call(WindowApi_1.setNoScrollBody, false)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchInputClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(ShareAction_1.default.ON_INPUT_CLICKED)];
            case 1:
                _a.sent();
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var watchCopyClick = function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ShareAction_1.default.ON_COPY_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCopyUrl)];
            case 2:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.copyToClipboard, url)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('copySuccessfully'))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var shareSagas = {
    watchPopupNoScroll: watchPopupNoScroll,
    watchInputClick: watchInputClick,
    watchCopyClick: watchCopyClick
};
exports.shareSagas = shareSagas;
